import { Helmet } from 'react-helmet-async'
import { Box } from '@mui/material'
import Header from "components/Header"
import Sidebar from "components/Sidebar"
import styles from './styles.module.scss'
import SingleJourneyContent from './SingleJourneyContent'
import { useSingleJourney } from './queries/useJourneyQuery'
import { useParams } from 'react-router-dom'

const SingleJourneyLayout = () => {
    const { id } = useParams()
    const { data: journey } = useSingleJourney(id)

    return (
        <Box className="rootWrapper">
            <Helmet>
                <title>{`Treegress Journey - ${journey?.label}`}</title>
            </Helmet>
            <Header />
            <Box className="srollContent">
                <Sidebar />
                <Box className={styles.testJourney}>
                    <SingleJourneyContent />
                </Box>
            </Box>
        </Box >
    )
}

export default SingleJourneyLayout